import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLang } from '../../contexts/LangContext';
import { supabase } from '../../lib/supabase';
import PasswordInput from '../../components/PasswordInput';

export default function RedefinirSenhaPage() {
  const navigate = useNavigate();
  const { lang } = useLang();
  const [checando, setChecando] = useState(true);
  const [linkValido, setLinkValido] = useState(false);
  const [novaSenha, setNovaSenha] = useState('');
  const [confirmar, setConfirmar] = useState('');
  const [error, setError] = useState('');
  const [salvando, setSalvando] = useState(false);
  const [sucesso, setSucesso] = useState(false);

  const tx = {
    pt: {
      title: 'Redefinir senha', subtitle: 'Escolha sua nova senha de acesso.',
      novaSenha: 'Nova senha', confirmarSenha: 'Confirmar senha',
      salvar: 'Salvar nova senha', salvando: 'Salvando...',
      naoCoincidem: 'As senhas não coincidem.', minCaracteres: 'A senha deve ter pelo menos 6 caracteres.',
      sucesso: 'Senha atualizada com sucesso!', irLogin: 'Ir para o login',
      linkInvalidoTitle: 'Link inválido ou expirado', linkInvalidoText: 'Peça um novo link de recuperação na tela de login.',
      voltarLogin: '← Voltar para o login',
    },
    en: {
      title: 'Reset password', subtitle: 'Choose your new password.',
      novaSenha: 'New password', confirmarSenha: 'Confirm password',
      salvar: 'Save new password', salvando: 'Saving...',
      naoCoincidem: 'Passwords do not match.', minCaracteres: 'Password must be at least 6 characters.',
      sucesso: 'Password updated successfully!', irLogin: 'Go to login',
      linkInvalidoTitle: 'Invalid or expired link', linkInvalidoText: 'Request a new recovery link on the login screen.',
      voltarLogin: '← Back to login',
    },
  }[lang];

  useEffect(() => {
    supabase.auth.getSession().then(({ data }) => {
      setLinkValido(!!data.session);
      setChecando(false);
    });
  }, []);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    if (novaSenha !== confirmar) { setError(tx.naoCoincidem); return; }
    if (novaSenha.length < 6) { setError(tx.minCaracteres); return; }
    setSalvando(true);
    const { error: updateError } = await supabase.auth.updateUser({ password: novaSenha });
    setSalvando(false);
    if (updateError) { setError(updateError.message); return; }
    setSucesso(true);
  }

  async function irParaLogin() {
    await supabase.auth.signOut();
    navigate('/login');
  }

  return (
    <div className="lp-page">
      <style>{`
        .lp-page { min-height:100vh; background:var(--surface-2); display:flex; align-items:center; justify-content:center; padding:20px; }
        .lp-card { width:100%; max-width:400px; background:var(--bg); padding:48px 40px; box-shadow:0 4px 32px rgba(37,28,25,0.1); border-radius:var(--r-card); }
        .lp-input { width:100%; padding:11px 13px; border:1.5px solid var(--divider); border-radius:var(--r-input); font-size:14px; color:var(--text); background:var(--surface); outline:none; margin-bottom:16px; font-family:'Inter',sans-serif; transition:border-color 0.2s; box-sizing:border-box; }
        .lp-input:focus { border-color:var(--accent); }
        .lp-btn { width:100%; padding:13px; background:var(--accent); color:var(--btn-text); border:none; border-radius:var(--r-btn); font-size:13px; font-weight:600; letter-spacing:0.08em; text-transform:uppercase; cursor:pointer; transition:background 0.2s; font-family:'Inter',sans-serif; margin-top:4px; }
        .lp-btn:hover { background:var(--accent-hover); }
        .lp-label { display:block; font-size:10px; font-weight:700; letter-spacing:0.1em; text-transform:uppercase; color:var(--text-3); margin-bottom:5px; }
        @media(max-width:480px){
          .lp-page{ align-items:stretch; justify-content:stretch; padding:0; }
          .lp-card{ width:100%; min-height:100vh; border-radius:0; box-shadow:none; padding:15vh 28px 40px; display:flex; flex-direction:column; justify-content:center; box-sizing:border-box; }
        }
      `}</style>
      <div className="lp-card">
        <div style={{ textAlign:'center', marginBottom:'32px' }}>
          <img src="/logo.svg" alt="Team Carol Macedo" style={{ height:'48px', width:'auto', objectFit:'contain' }} />
        </div>

        {checando ? (
          <div style={{ textAlign:'center', color:'var(--text-2)', fontSize:'13px' }}>...</div>
        ) : !linkValido ? (
          <>
            <div style={{ fontFamily:"'Inter', sans-serif", fontSize:'26px', color:'var(--text)', textAlign:'center', marginBottom:'8px' }}>{tx.linkInvalidoTitle}</div>
            <div style={{ fontSize:'13px', color:'var(--text-2)', textAlign:'center', marginBottom:'24px', lineHeight:1.6 }}>{tx.linkInvalidoText}</div>
            <button className="lp-btn" onClick={() => navigate('/login')}>{tx.voltarLogin}</button>
          </>
        ) : sucesso ? (
          <>
            <div style={{ padding:'11px 13px', background:'rgba(76,175,80,0.08)', border:'1px solid rgba(76,175,80,0.25)', color:'#2E7D32', borderRadius:'var(--r-btn)', fontSize:'13px', textAlign:'center', marginBottom:'20px' }}>
              ✓ {tx.sucesso}
            </div>
            <button className="lp-btn" onClick={irParaLogin}>{tx.irLogin}</button>
          </>
        ) : (
          <>
            <div style={{ fontFamily:"'Inter', sans-serif", fontSize:'26px', color:'var(--text)', textAlign:'center', marginBottom:'8px' }}>{tx.title}</div>
            <div style={{ fontSize:'13px', color:'var(--text-2)', textAlign:'center', marginBottom:'28px' }}>{tx.subtitle}</div>

            {error && (
              <div style={{ padding:'11px 13px', background:'rgba(229,57,53,0.07)', border:'1px solid rgba(229,57,53,0.2)', color:'#C62828', borderRadius:'var(--r-btn)', fontSize:'13px', marginBottom:'16px' }}>
                {error}
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <label className="lp-label">{tx.novaSenha}</label>
              <PasswordInput className="lp-input" value={novaSenha} onChange={e => setNovaSenha(e.target.value)} placeholder="••••••••" required />
              <label className="lp-label">{tx.confirmarSenha}</label>
              <PasswordInput className="lp-input" value={confirmar} onChange={e => setConfirmar(e.target.value)} placeholder="••••••••" required />
              <button className="lp-btn" type="submit" disabled={salvando}>{salvando ? tx.salvando : tx.salvar}</button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
